import { render, staticRenderFns } from "./specialBanner.vue?vue&type=template&id=3330843c&scoped=true&"
var script = {}
import style0 from "./specialBanner.vue?vue&type=style&index=0&id=3330843c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3330843c",
  null
  
)

export default component.exports